module.exports = __webpack_public_path__ + "img/Angel2.debb2b6c.jpg";